<template>
    <div>
        <queue-modal v-ref:queue-modal></queue-modal>
        <form-visit-scheduling v-ref:scheduling :on-create="visitCreated"
                               :on-update="visitUpdated"></form-visit-scheduling>
    </div>
</template>
<script>
    const Promise = require('bluebird')
    const bus = require('sci/std/bus')
    const toastr = require('toastr')
    const QueueModal = require('components/queue/Modal.vue')

    const FormVisitScheduling = require('components/form/VisitScheduling.vue')
    const {matrixClient} = require('sci/helpers')

    export default {
        components: {
            FormVisitScheduling,
            QueueModal
        },
        created() {
            bus.$matrix = Promise.props({
                profile: matrixClient.get('Carregando perfil', '/sessions/instance')
                // instanceProfile: client.get('Carregando informações', '/instance/profile'),
                // websites: client.get('Carregando website', '/websites')
            })
        },
        ready() {
            bus.$on('visits:update', ({form, visit}) => {
                this.$refs.scheduling.update(form, visit)
            })

            bus.$on('visits:view', ({form, visit}) => {
                this.$refs.scheduling.view(form, visit)
            })

            bus.$on('visits:finish', ({form, visit}) => {
                this.$refs.scheduling.finish(form, visit)
            })

            bus.$on('visits:cancel', ({form, visit}) => {
                this.$refs.scheduling.cancel(form, visit)
            })

            bus.$on('visits:new', ({form, properties, constructions}) => {
                this.$refs.scheduling.create(form, properties, constructions)
            })

            bus.$on('visits:show-pre-append-items', ({form, items}) => {
                this.$refs.scheduling.preAppendItems(form, items)
            })

            bus.$on('visits:show-visit-statement', ({form, visit}) => {
                this.$refs.scheduling.showVisitStatement(form, visit)
            })

            bus.$on('queue:enqueue', (a, b, c) => {
                this.$refs.queueModal.enqueue(a.task, a.version, a.request)
            })

            bus.$on('queue:watch', (id) => {
                this.$refs.queueModal.watch(id)
            })
        },
        methods: {
            visitCreated(visit) {
                toastr.info('Visita criada')

                location.href = `/forms/${visit.form_id}/visits`

                this.$refs.scheduling.hide()
            },
            visitUpdated(visit, mode) {
                if (mode === 'cancel') {
                    toastr.info('Visita cancelada')
                } else if (mode === 'finish') {
                    toastr.info('Visita finalizada')
                } else {
                    toastr.info('Visita atualizada')
                }

                this.$refs.scheduling.hide()

                bus.$emit('form:refresh-timeline')
                bus.$emit('form:refresh-visits')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Bus.vue?375e433d